import React, { useEffect } from "react";
import RegisterBiScreen from "../screens/RegisterBiScreen";
import { connect } from "react-redux";
import get from "../../utils/get";
import * as actions from "../actions/data";

import * as createAction from "../../users/actions/create";
import * as departmentActions from "../../department/actions/register";

const RegisterBiContainer = (props) => {
  useEffect(() => {
    props.getOptions();
    props.getSubOptions();
    // eslint-disable-next-line
  }, []);
  return <RegisterBiScreen {...props} />;
};

const mapStateToProps = (state) => ({
  isLoadingRegister: get(state, "test.data.isLoadingRegister"),
  data: get(state, "department.register.data"),
  dataSub: get(state, "department.register.dataSub"),
  message: get(state, "test.data.message"),
});

const mapActionsToProps = { ...actions, ...departmentActions, ...createAction };

export default connect(mapStateToProps, mapActionsToProps)(RegisterBiContainer);
